import { authenticatedFetch } from './api_utils';
import { functionEndpoint } from './endpoints';

import { readApiError } from '../utils/apiError';
export { readApiError as readFunctionError } from '../utils/apiError';

async function postFunction(name, body) {
  const response = await authenticatedFetch(functionEndpoint(name), {
    method: 'POST',
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    throw new Error(await readApiError(response));
  }
  return response.json();
}

export function manageExternalConnection(body) {
  return postFunction('manage_external_connection', body);
}

export function browseExternalSource(body) {
  return postFunction('browse_external_source', body);
}
